import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import * as yup from "yup";
const { useAuthContext } = require("../../context/AuthContext");

export default function addDebtModal({
  handleConfirmation,
  open,
  setOpen,
  amount,
  debtId,
  setDebtToDelete,
}) {
  const [signers, setSigners] = useState(null);
  const [signer, setSigner] = useState(null);
  const [yearDecision, setYearDecision] = useState("");
  const [decisionNumber, setDecisionNumber] = useState("10");
  const [comments, setComments] = useState("");
  const [years, setYears] = useState([]);
  const { setNotification, setLoading } = useAuthContext();

  const getSigners = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getSigners`,
        { withCredentials: true },
      );
      setSigners(response.data);
    } catch (error) {
      console.log(error);
      setNotification({
        open: true,
        message: "Αποτυχία στην Λήψη Υπογραφόντων.",
        color: "error",
      });
    }
  };

  const isSubmitDisabled =
    !signer?.id || !yearDecision || !decisionNumber || !amount;

  const discountDataSchema = yup.object().shape({
    discount: yup.number().required().positive(),
    decisionNumber: yup
      .number()
      .required()
      .positive()
      .integer("To Πεδίο Έτος Απόφασης πρέπει να είναι ακέραιος"),
  });

  const addDiscountData = async () => {
    try {
      await discountDataSchema.validate({
        discount: Number(amount),
        decisionNumber: Number(decisionNumber),
      });
      const formData = {
        signerId: signer.id,
        yearDecision: yearDecision,
        decisionNumber: decisionNumber,
        comments: comments,
        discount: amount,
      };
      await handleConfirmation(formData);
    } catch (error) {
      setNotification({
        open: true,
        color: "error",
        message: error.message,
      });
    }
  };

  const getFilterArrays = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getListOfYears`,
        {
          withCredentials: true,
        },
      );
      setYears(response.data.years);

      if (response.data.years.length > 0) {
        setYearDecision(response.data.years[response.data.years.length - 1]);
      }
    } catch (error) {
      console.error("Σφάλμα κατά την λήψη των ετών:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSigners();
    getFilterArrays();
  }, []);

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        sx={{
          height: "100%",
        }}
      >
        <DialogTitle style={{ fontSize: "1.2rem" }}>
          Προσθήκη Έκπτωσης
        </DialogTitle>
        <DialogContent>
          <FormControl
            sx={{
              mt: 5,
              mb: 2,
            }}
            required
            fullWidth
          >
            <InputLabel>Υπογράφων</InputLabel>
            <Select
              sx={{
                mb: 1,
              }}
              value={signer?.value || ""}
              label="Υπογράφων"
            >
              {signers ? (
                signers.map((_signer, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      setSigner({
                        id: _signer.id,
                        value: _signer.value,
                      });
                    }}
                    value={_signer.value}
                  >
                    {_signer.value}
                  </MenuItem>
                ))
              ) : (
                <MenuItem key="no-signers">
                  Δεν βρέθηκαν ενεργοί υπογράφοντες
                </MenuItem>
              )}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              mb: 1,
            }}
            required
            fullWidth
          >
            <InputLabel id="demo-simple-select-label">Έτος Απόφασης</InputLabel>
            <Select
              label="Έτος Απόφασης"
              value={yearDecision || ""}
              onChange={(e) => setYearDecision(e.target.value)}
            >
              {years.map((year, index) => (
                <MenuItem key={index} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            sx={{
              mb: 1,
            }}
            fullWidth={true}
            margin="normal"
            label="Ποσό Έκπτωσης"
            variant="outlined"
            value={amount}
            onChange={(e) =>
              setDebtToDelete((prevState) => ({
                ...prevState,
                amount: e.target.value,
              }))
            }
            error={!!amount && isNaN(Number(amount))}
            helperText={
              !!amount && isNaN(Number(amount)) ? "Πρέπει να είναι αριθμός" : ""
            }
          />
          <TextField
            sx={{
              mb: 1,
            }}
            fullWidth={true}
            margin="normal"
            label="Αριθμός Απόφασης"
            variant="outlined"
            value={decisionNumber}
            onChange={(e) => setDecisionNumber(e.target.value)}
            error={!!decisionNumber && isNaN(Number(decisionNumber))}
            helperText={
              !!decisionNumber && isNaN(Number(decisionNumber))
                ? "Πρέπει να είναι αριθμός"
                : ""
            }
          />

          <TextField
            sx={{
              mb: 1,
            }}
            multiline
            rows={4}
            fullWidth={true}
            margin="normal"
            variant="outlined"
            placeholder="Σχόλια"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            style={{
              width: "99%",
              marginTop: "16px",
              marginBottom: "16px",
              resize: "vertical",
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 1 }}>
          <Button
            color="error"
            onClick={() => {
              setOpen(false);
              setDebtToDelete({ amount: null, id: null });
            }}
          >
            Ακύρωση
          </Button>
          <Button
            color="success"
            variant="contained"
            onClick={async () => {
              setOpen(false);
              if (
                !isSubmitDisabled &&
                !isNaN(Number(amount)) &&
                !isNaN(Number(decisionNumber))
              ) {
                addDiscountData();
              }
            }}
            disabled={
              isSubmitDisabled ||
              isNaN(Number(amount)) ||
              isNaN(Number(decisionNumber))
            }
          >
            Αποστολή
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
